const Perfiles = () => {

    return(
        <div>
            <p>
                Perfiles
            </p>
        </div>
    )
}
export default Perfiles
